export default "ALTER TABLE `private_post_factiiis` ADD `number` real;--> statement-breakpoint\nALTER TABLE `snapshot_factiiis` ADD `number` real;";